<template>
    <div :class="_class">
        <div v-for="(file, index) in files">
            <label> {{ label }}
                <template v-if="file.handle">
                    <span :class="file.uploadClass" class='fa'></span>
                </template>
            </label>
            <input :data-index="index" @change="onFileChange" @focus="selected=index"
                   class="form-control" type="file">
            <input :data-index="index" :id="'file-name-'+index" :name="name" class="form-control" type="hidden"
                   v-model="file.filename">
        </div>
    </div>
</template>

<script>
export default {
    name: "MImageUpload",
    props: {

        name: {
            type: String,
            default: null
        },
        label: {
            type: String,
            default: 'Image'
        },
        folder: {
            type: String,
            default: 'images'
        },
        filename: {
            type: String,
            default: null
        },
        upload_url: {
            type: String,
            required: true
        },
        _class: {
            type: String,
            default: 'col-md-4 col-sm-12'
        }

    },
    data() {
        return {
            files: [
                {
                    anexo: '',
                    description: '',
                    uploadClass: null,
                    handle: false,
                    filename: null,
                }
            ],
            uploadClass: {
                refresh: {'fa-refresh': true, 'text-info': true, 'rotate': true},
                success: {'fa-check': true, 'text-success': true},
                error: {'fa-close': true, 'text-danger': true},
            },
            selected: 0,
            image: {
                id: null,
                description: null,
                label: ''
            },
        }
    },
    methods: {
        onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;

            let index = e.target.getAttribute('data-index')

            this.files[index].handle = true
            this.files[index].uploadClass = this.uploadClass.refresh

            var file = files[0];
            if (file.type.match('image.*')) {
                let app = this
                this.resizeImage(files[0], function (result) {
                    app.uploadImage(result, file.name, index);
                });
            } else {
                this.files[index].uploadClass = this.uploadClass.error
                showMessage('e', 'This file is not an image')
            }

            this.files[this.selected].anexo = files[0]
            this.$emit("changeFile", this.files)

        },

        addFile() {
            this.files.push({
                anexo: '',
                description: '',
                uploadClass: null,
                handle: false,
                filename: null,
            });
            this.$emit("changeFile", this.files)
        },

        selectImage(image) {
            this.image = image
        },

        resizeImage(file, callback) {
            let app = this;
            if (window.File && window.FileReader && window.FileList && window.Blob) {
                // var filesToUploads = document.getElementById('imageFile').files;
                // var file = filesToUploads[0];
                if (file) {

                    var reader = new FileReader();
                    // Set the image once loaded into file reader
                    reader.onload = function () {

                        var image = new Image();
                        image.onload = function () {

                            var canvas = document.createElement("canvas");
                            var ctx = canvas.getContext("2d");
                            ctx.drawImage(image, 0, 0);

                            var MAX_WIDTH = 600;
                            var MAX_HEIGHT = 600;
                            var width = image.width;
                            var height = image.height;

                            if (width > height) {
                                if (width > MAX_WIDTH) {
                                    height *= MAX_WIDTH / width;
                                    width = MAX_WIDTH;
                                }
                            } else {
                                if (height > MAX_HEIGHT) {
                                    width *= MAX_HEIGHT / height;
                                    height = MAX_HEIGHT;
                                }
                            }
                            canvas.width = width;
                            canvas.height = height;
                            var ctx = canvas.getContext("2d");
                            ctx.drawImage(image, 0, 0, width, height);

                            callback(canvas.toDataURL(file.type));
                        }

                        image.src = this.result;
                    }

                    reader.readAsDataURL(file);

                    reader.onabort = function () {
                        showMessage('e', "The upload was aborted");
                    }

                    reader.onerror = function () {
                        showMessage('e', "There was an error reading the file");
                    }
                }

            } else {
                showMessage('e', 'The File APIs are not fully supported in this browser.');
            }
        },
        uploadImage(dataUrl, filename, index) {
            let app = this
            axios.post(this.upload_url, {
                dataEncoded: dataUrl,
                filename: filename,
                folder: app.folder
            })
                .then((response) => {
                    app.files[index].uploadClass = this.uploadClass.success
                    app.files[index].filename = response.data.data.filename
                    //showMessage('s', 'Upload concluído');
                })
                .catch(error => {

                    app.files[index].uploadClass = this.uploadClass.error

                    if (error.response.status === 500) {
                        showMessage('e', 'Could not complete request');
                    }

                    if (error.response.status === 401) {
                        showMessage('w', error.response.data.server_error);
                    }

                    if (error.response.status === 405) {
                        showMessage('w', 'Upload URL is not valid');
                    }

                    if (error.response.status === 400) {
                        this.errors = error.response.data.errors || {};
                        showMessage('w', 'Fill in all mandatory fields');
                    }
                })
                .finally(() => null)
        },
    },
    mounted() {
        if (this.filename) {
            this.files[0].filename = this.filename
        }
    }
}
</script>

<style scoped>

.image-action {
    position: absolute;
    top: 0;
    color: white;
}

.image-action-delete {
    right: 1%;
}

.image-action-edit {
    right: 25%;
}

.image-description {
    width: 100%;
    height: 30%;
    overflow-y: scroll;
    position: absolute;
    bottom: 0;
    text-align: center;
    color: #1b1e21;
}

.text-primary {
    color: #1ab394;
}

.rotate {

    -webkit-animation: spin 2s linear infinite;
    -moz-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
}

@-moz-keyframes spin {
    100% {
        -moz-transform: rotate(360deg);
    }
}

@-webkit-keyframes spin {
    100% {
        -webkit-transform: rotate(360deg);
    }
}

@keyframes spin {
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}
</style>
